import { Arrange, Container, Spacer, Text, TooltipBox } from '@loomhq/lens';
import clamp from 'lodash/clamp';
import React, { useRef } from 'react';

import { secondsToVideoTS } from 'utilities/time';

import useOnClickOutside from 'hooks/useOnClickOutside';

import styles from './styles.module.less';

const PillText = ({ children }) => (
  <Container
    backgroundColor="rgba(255,255,255,0.1)"
    width="max-content"
    radius="medium"
    paddingX="xsmall"
  >
    <Text size="small" fontWeight="medium" color="hsla(240, 40%, 97%, 0.6)">
      {children}
    </Text>
  </Container>
);

interface Props {
  secs: number;
  x: number;
  y: number;
  minX?: number;
  maxX: number;
  mouseDown: boolean;
  onClickOutside?: () => void;
}

const HandleTooltip = ({
  secs,
  x,
  y,
  minX = 0,
  maxX,
  mouseDown,
  onClickOutside,
}: Props): JSX.Element => {
  let tooltipWidth = 70;

  if (secs >= 3600) {
    tooltipWidth = 90;
  }

  if (!mouseDown) {
    tooltipWidth = 154;
  }

  const tooltipHeight = 60;
  const tooltipMargin = 20;

  const clickOutsideRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(clickOutsideRef, onClickOutside);

  return (
    <foreignObject
      x={clamp(x - tooltipWidth / 2, minX, maxX - tooltipWidth)}
      y={y + tooltipMargin}
      width={tooltipWidth}
      height={tooltipHeight}
      className={styles.overflowVisible}
    >
      <div ref={clickOutsideRef}>
        <TooltipBox>
          <Text
            htmlTag="div"
            alignment="center"
            className={styles.timeDisplay}
            size="small"
            fontWeight="medium"
          >
            {secondsToVideoTS(secs, 1)}
          </Text>
          {!mouseDown && (
            <>
              <Spacer top="xsmall" />
              <Arrange justifyContent="center" gap="xsmall">
                <Text
                  size="small"
                  fontWeight="medium"
                  color="hsla(240, 40%, 97%, 0.6)"
                >
                  Use
                </Text>
                <PillText>&larr;</PillText>
                <PillText>&rarr;</PillText>
                <Text
                  size="small"
                  fontWeight="medium"
                  color="hsla(240, 40%, 97%, 0.6)"
                >
                  to nudge
                </Text>
              </Arrange>
            </>
          )}
        </TooltipBox>
      </div>
    </foreignObject>
  );
};

export default HandleTooltip;
